"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rangeOfELs = exports.EL = void 0;
const elToXML_1 = require("./elToXML");
let currentID = 0;
/**
 * EL: a simplified XML DOM functionality that implements {@link JsonEL} interface.
 */
class EL {
    tag;
    attr;
    children;
    id;
    range;
    constructor(tag, attr = {}, children = [], range = null, id) {
        // if(!tag) {
        //     error(`${JSON.stringify(tag)} is invalid tag.`);
        // }
        this.tag = tag;
        this.attr = attr;
        this.children = children;
        this.range = range;
        // this.textCache = null;
        this.id = id ?? ++currentID;
    }
    get isControl() {
        return this.tag[0] === "_";
    }
    copy(deep = true, copyID = false) {
        const el = new EL(this.tag, { ...this.attr }, (deep
            ? this.children.map(child => child instanceof EL ? child.copy(true) : child)
            : [...this.children]), this.range && [...this.range], copyID ? this.id : undefined);
        Object.setPrototypeOf(el, Object.getPrototypeOf(this));
        return el;
    }
    json(withControlEl = false, withProperties = false) {
        const children = [];
        for (const el of this.children) {
            if (!(el instanceof EL || typeof el === "string")) {
                console.error("[EL.json]", JSON.stringify(this));
                throw JSON.stringify(this);
            }
            if (typeof el === "string") {
                children.push(el);
            }
            else {
                const js = el.json(withControlEl, withProperties);
                if (withControlEl || el.tag[0] !== "_") {
                    children.push(js);
                }
                else {
                    children.push(...js.children);
                }
            }
        }
        const joinedChildren = [];
        for (const child of children) {
            const last = joinedChildren[joinedChildren.length - 1];
            if (typeof last === "string" && typeof child === "string") {
                joinedChildren[joinedChildren.length - 1] = last + child;
            }
            else {
                joinedChildren.push(child);
            }
        }
        const attr = { ...this.attr };
        if (withProperties) {
            attr["__id"] = JSON.stringify(this.id);
            attr["__range"] = JSON.stringify(this.range);
        }
        return {
            tag: this.tag,
            attr,
            children: joinedChildren,
        };
    }
    text() {
        if (this.children.length === 0)
            return "";
        if (this.children.length === 1 && typeof this.children[0] === "string")
            return this.children[0];
        return this.children.map(child => child instanceof EL ? child.text() : child).join("");
    }
    wrapXML(inner) {
        return (0, elToXML_1.wrapXML)(this, inner);
    }
    outerXML(withControlEl = false) {
        return (0, elToXML_1.outerXML)(this, withControlEl);
    }
    innerXML(withControlEl = false) {
        return (0, elToXML_1.innerXML)(this, withControlEl);
    }
}
exports.EL = EL;
const rangeOfELs = (els) => {
    let start = null;
    let end = null;
    for (const el of els) {
        if (el instanceof EL) {
            const r = el.range ?? (0, exports.rangeOfELs)(el.children);
            if (r) {
                start = Math.min(r[0], start ?? r[0]);
                end = Math.max(r[1], end ?? r[1]);
            }
        }
    }
    return (start !== null && end !== null) ? [start, end] : null;
};
exports.rangeOfELs = rangeOfELs;
//# sourceMappingURL=index.js.map